import {onReady, listener, findID, eventHandler} from "../../../../modules/vegas/js/util";
import Calculation from "./Calculation";

listener('submit', '#form-calc-delivery', function (el) {
	const calc = new Calculation();
	calc.submit(el);
}, true);

listener('click', '#form-calc-delivery [data-addr]', function (el) {
	el.closest('form').requestSubmit();
});

onReady(() => {
	let form = findID('form-calc-delivery');

	if (!form) return;

	let input = form.querySelector('[name=address]');

	if (input.value) {
		form.requestSubmit();
	}
});
